// Feature gates are 404-not-403: a screen this tenant lacks does not exist for them (ADR 0003 §4).
export function NotFound() {
  return (
    <section className="page">
      <h1>Not found</h1>
      <p className="muted">There is nothing at this address.</p>
    </section>
  )
}
